export enum OperationType {
  DEPOSIT = 'DEPOSIT',
  TRANSFER_WITHOUT_FINANCIAL = 'TRANSFER_WITHOUT_FINANCIAL',
  WITHDRAW = 'WITHDRAW',
  DELIVERY = 'DELIVERY',
  TRADE_FROM = 'TRADE_FROM',
  TRADE_TO = 'TRADE_TO',
  RETIREMENT =  'RETIREMENT',
  MINT = 'MINT',
  TRADE = 'TRADE',
}